RivalIQ.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.SocialChannels = Backbone.Collection.extend({
        model: App.models.SocialChannel,

        comparator: function (channel) {
            return channel.get('source');
        }
    });
});
